'use client';

type ArTryOnSdk = typeof import('@zeelool/ar-try-on');

let sdkModulePromise: Promise<ArTryOnSdk> | undefined;

/** 仅加载模块；实例、摄像头与 telemetry 仍由当前 AR 会话管理。 */
export function loadArTryOnSdk(): Promise<ArTryOnSdk> {
  if (!sdkModulePromise) {
    const pending: Promise<ArTryOnSdk> = import('@zeelool/ar-try-on').catch((error: unknown) => {
      if (sdkModulePromise === pending) {
        sdkModulePromise = undefined;
      }
      throw error;
    });
    sdkModulePromise = pending;
  }

  return sdkModulePromise;
}
